import { render, staticRenderFns } from "./basketball.vue?vue&type=template&id=6b189b01&scoped=true&"
import script from "./basketball.vue?vue&type=script&lang=js&"
export * from "./basketball.vue?vue&type=script&lang=js&"
import style0 from "./basketball.vue?vue&type=style&index=0&id=6b189b01&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b189b01",
  null
  
)

export default component.exports